export const getTestData = (store) => store.labTest.data;
